export enum EImportErrorCode {
  FileNotFound = 'FILE_NOT_FOUND',
  InvalidFileType = 'INVALID_FILE_TYPE',
  InvalidFileContent = 'INVALID_FILE_CONTENT',
  NoDataFetched = 'NO_DATA_FETCHED',
}
